import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from "cdbreact";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import SideButton from "./buttons/SideButton.js";
import Dropdown from "react-bootstrap/Dropdown";
import "./Sidebar.css";
import logo from "./images/cauris.png";
import { useHistory } from "react-router-dom";
import {
  CONVERSATION_AGE_GROUPS,
  groupConversations,
} from "./groupConversations";
import {
  conversationId,
  deleteConversationId,
  loadConversationPrefs,
  saveConversationPrefs,
  splitStarredConversations,
  toggleStarredId,
} from "./conversationPrefs";

const Sidebar = (props) => {
  const history = useHistory();

  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(props.selected_index);
  const [partnerReports, setPartnerReports] = useState([]);

  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  const [conversations, setConversations] = useState([]);
  const [prefs, setPrefs] = useState(() => loadConversationPrefs(localStorage));
  const conversationRequest = useRef(0);

  // const [chatHistory, setChatHistory] = useState();

  const setSelectedReport = props.setSelectedReport;

  const chatHistory = useMemo(() => {
    let visible = [];
    if (
      partners != undefined &&
      partners.length > 0 &&
      partners[props.selected_index]
    ) {
      const partnerId = partners[props.selected_index].partner_id;
      visible = conversations.filter((report) => {
        return (
          report.partner_id == partnerId && report.conversation_name != ""
        );
      });
    }
    const split = splitStarredConversations(visible, prefs);
    return { starred: split.starred, ...groupConversations(split.rest) };
  }, [conversations, partners, prefs, props.selected_index]);

  function persistPrefs(next) {
    setPrefs(saveConversationPrefs(next, localStorage));
  }

  function toggleStar(report) {
    const id = conversationId(report);
    if (!id) {
      return;
    }
    persistPrefs(toggleStarredId(prefs, id));
  }

  function deleteConversation(report) {
    const id = conversationId(report);
    if (!id) {
      return;
    }
    const label = report.title || report.conversation_name || "this conversation";
    const confirmed = window.confirm(
      `Delete "${label}" from this browser? It will stay hidden on this device.`
    );
    if (!confirmed) {
      return;
    }
    persistPrefs(deleteConversationId(prefs, id));
    try {
      const current = JSON.parse(localStorage.getItem("selectedReport_v2"));
      if (current && String(current.conversation_id) === String(report.id)) {
        localStorage.removeItem("selectedReport_v2");
        setSelectedReport(undefined);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // function load_partner_data(partner_data) {
  //   console.log("LOAD PARTNER DATA", partner_data);
  //   var partner = partner_data.partner_name;
  //   for (var c in partner_data.countries) {
  //     axios
  //       .get(
  //         process.env.REACT_APP_API_DOMAIN +
  //           "/get_summary?country=" +
  //           partner_data.countries[c] +
  //           "&company=" +
  //           partner.toLowerCase()
  //       )
  //       .then((response) => {
  //         var partner_update = response.data;
  //         partner_update.metadata = partner_data;
  //         setPartnerReports((oldArray) => [...oldArray, response.data]);
  //         props.setPartnerMetadata(partner_data);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }

  function load_partner_data(partner_data) {
    console.log("LOAD PARTNER DATA", partner_data);

    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/getReportsByOwner",
        {
          ownerId: profile.email,
          partnerId: partner_data.partner_id,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        // setPartnerReports(response.data.reports);
        props.setPartnerMetadata(partner_data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (props.partnerMetadata) {
      setProfile(JSON.parse(localStorage.getItem("g_profile")));

      let newProfile = JSON.parse(localStorage.getItem("g_profile"));
      const requestId = ++conversationRequest.current;
      const refreshedConversationId =
        props.updateConversations && props.updateConversations.conversationId;

      console.log("profile.profile", newProfile);
      console.log("get.profile", localStorage.getItem("g_profile"));
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/get_conversations",
          {
            partner_id: props.partnerMetadata.partner_id,
            sender_id: newProfile.email,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (requestId !== conversationRequest.current) {
            return;
          }
          let filtered = response.data.rows.filter((obj) => obj.id !== null);
          if (refreshedConversationId != null) {
            const respondedAt = new Date().toISOString();
            filtered = filtered.map((row) =>
              String(row.id) === String(refreshedConversationId)
                ? { ...row, timestamp: respondedAt }
                : row
            );
          }

          console.log("CHATX", filtered, partners);
          setConversations(filtered);
          if (props.selectedConversationId) {
            let obj = {};
            obj.id = props.selectedConversationId;
            change_conversation(obj);
            props.setConversationId(undefined);
          }
        })
        .catch((error) => {
          console.log(error);
          localStorage.setItem("g_profile", null);
          history.push("/logout");
        });
    }
  }, [props.updateConversations, props.partnerMetadata]);
  // setChatHistory(
  //   parseChartHistory(JSON.parse(localStorage.getItem("conversations_v2")))
  // );
  // }, [props.updateConversations, partners]);

  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/get_partners",
        {
          sender_id: profile.email,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setPartners(response.data);

        console.log("response.data", response.data);
        if (response.data.length > 0) {
          load_partner_data(response.data[selectedPartner]);
        } else {
          props.setArePartnersAvailable(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedPartner, props.selected_index]);

  function change_report(report) {
    console.log("SIDEBAR", report);
    window.location.href = "/jam?reportId=" + report.id;
  }

  function change_conversation(conversation_id) {
    // localStorage.setItem("selectedReport_v2", JSON.stringify(conversation));
    // setSelectedReport(conversation);
    props.setMessagesLoading(true);
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/get_messages",
        {
          conversation_id: conversation_id.id,
          partner_id: props.partnerMetadata.partner_id,
          token: localStorage.getItem("token"),
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        // setChatHistory(response.data.rows);

        if (response.data.history.length > 0) {
          response.data["portco"] = props.partnerMetadata.partner_name;
          response.data["conversation_id"] = conversation_id.id;
          console.log("TEST THIS", response.data);
          localStorage.setItem(
            "selectedReport_v2",
            JSON.stringify(response.data)
          );

          setSelectedReport(response.data);
          props.setMessagesLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        backgroundColor: "#FFFFFF",
      }}
    >
      <CDBSidebar textColor="#0D0D0D" backgroundColor="#F9F9F9" height="100%">
        <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
          {/* <img src={logo} height="30" weight="30" alt=""></img> */}
          Credit Copilot
        </CDBSidebarHeader>

        <CDBSidebarContent>
          <div className="sidebar_menu">
            <Dropdown>
              {partners.length > 1 ? (
                <div>
                  {" "}
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    size="sm"
                  >
                    Change Partner
                  </Dropdown.Toggle>
                </div>
              ) : (
                <div></div>
              )}

              {partnerReports.length > 0 ? (
                <div className="sidebarJamTitle">Jams</div>
              ) : (
                <div className="conversationTitle"></div>
              )}

              <Dropdown.Menu>
                {partners.map((partner, index) => (
                  <Dropdown.Item key={index} href={"?selected_index=" + index}>
                    {partner.partner_name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <CDBSidebarMenu>
            {partnerReports.map((report, index) => (
              <SideButton
                key={index}
                onClick={() => change_report(report)}
                button_text={report.title}
                button_handler={change_report}
                report={report}
                isReport={true}
              ></SideButton>
            ))}
          </CDBSidebarMenu>

          {chatHistory.starred.length > 0 ? (
            <div>
              <div className="conversationTitle">Starred</div>
              <CDBSidebarMenu>
                {chatHistory.starred.map((report, index) => (
                  <SideButton
                    key={conversationId(report) || index}
                    onClick={() => change_conversation(report)}
                    button_text={report.title}
                    button_handler={change_conversation}
                    report={report}
                    starred={true}
                    onToggleStar={toggleStar}
                    onDelete={deleteConversation}
                  ></SideButton>
                ))}
              </CDBSidebarMenu>
            </div>
          ) : null}
          {CONVERSATION_AGE_GROUPS.map((group) =>
            chatHistory[group.key].length > 0 ? (
              <div key={group.key}>
                <div className="conversationTitle">{group.label}</div>
                <CDBSidebarMenu>
                  {chatHistory[group.key].map((report, index) => (
                    <SideButton
                      key={conversationId(report) || index}
                      onClick={() => change_conversation(report)}
                      button_text={report.title}
                      button_handler={change_conversation}
                      report={report}
                      starred={false}
                      onToggleStar={toggleStar}
                      onDelete={deleteConversation}
                    ></SideButton>
                  ))}
                </CDBSidebarMenu>
              </div>
            ) : null
          )}
        </CDBSidebarContent>

        <CDBSidebarFooter style={{ textAlign: "center" }}>
          <div
            style={{
              padding: "20px 5px",
            }}
          >
            {/* Cauris Finance 2025 */}
          </div>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default Sidebar;
